module.exports = __webpack_public_path__ + "img/ClickForSound_17.34de03ef.png";